import { render } from "./StorySubmission.vue?vue&type=template&id=c9cfce76&scoped=true"
import script from "./StorySubmission.vue?vue&type=script&lang=js"
export * from "./StorySubmission.vue?vue&type=script&lang=js"

import "./StorySubmission.vue?vue&type=style&index=0&id=c9cfce76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c9cfce76"

export default script